import { useEffect } from 'react'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { Cmdtypes } from 'src/constants/cmdtypes'
import OT, { OTError } from '@opentok/client'
import {
  ResetCallTime,
  ResetCameraStatus,
  ResetEmptyComponentStatus,
  setCameraStatus,
} from 'src/store/Reducer/page/cameraPageSlice'
import { Errcode } from 'src/constants/errcode'

import { ResponseDataBody, ResponseDataType } from 'src/types/websocket'
import { eventBus } from 'src/api/eventBus'
import { useLocation } from 'react-router-dom'
import { SocketSender } from 'src/api/socket'
import { setLoadingStatus } from 'src/store/Reducer/common/commonSlice'
import { setModalItems } from 'src/store/Reducer/common/modalSlice'
import { useTranslation } from 'react-i18next'

const useCameraEventBus = (SessionRef: any, publisherRef: any) => {
  const dispatch = useAppDispatch()
  const { pathname } = useLocation()
  const { t } = useTranslation()
  let cameraSessionHandler: NodeJS.Timeout | undefined

  useEffect(() => {
    const CameraStartResponseListener = eventBus.subscribe<ResponseDataBody.CameraStart>(
      Cmdtypes.CAMERA_START,
      handleCameraStartResponse,
    )
    const CameraStopResponseListener = eventBus.subscribe<unknown>(
      Cmdtypes.CAMERA_STOP,
      handleCameraStopResponse,
    )

    return () => {
      !!cameraSessionHandler && clearTimeout(cameraSessionHandler)
      CameraStartResponseListener.unsubscribe()
      CameraStopResponseListener.unsubscribe()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname])

  const handleCameraStartResponse = (message: ResponseDataType<ResponseDataBody.CameraStart>) => {
    const { Header, Body } = message.responseData
    const { TokenID, SessionID } = Body
    const session = OT.initSession('47764501', SessionID)
    SessionRef.current = session

    if (Header.ErrCode === Errcode.SUCCESS) {
      dispatch(setLoadingStatus(true))
      dispatch(setCameraStatus('loading'))
      const handleError = (error: OTError | undefined) => {
        error && console.log(error.message)
      }

      const publisher = OT.initPublisher(
        'publisher',
        {
          insertMode: 'append',
          width: '120px',
          height: '200px',
          fitMode: 'cover',
        },
        (error) => {
          // 웹에서 마이크와 카메라가 권한이 없을 때
          console.warn('카메라, 마이크 권한이 없을때')
        },
      )

      publisherRef.current = publisher

      const sessionOn = (event: OT.Event<'streamCreated', OT.Session> & { stream: OT.Stream }) => {
        session.subscribe(
          event.stream,
          'subscriber',
          {
            insertMode: 'append',
            width: '100%',
            height: '100%',
            fitMode: 'cover',
          },
          handleError,
        )
      }
      const connectSessionHandler = (error: OT.OTError | undefined) => {
        if (error) {
          handleError(error)
        } else {
          session.publish(publisher, handleError)
          dispatch(setCameraStatus('active'))
        }
      }

      cameraSessionHandler = setTimeout(() => {
        if (window.location.pathname === '/camera') {
          session.on('streamCreated', sessionOn)
          session.connect(TokenID, connectSessionHandler)
        } else {
          dispatch(SocketSender(Cmdtypes.CAMERA_STOP))
          SessionRef.current?.disconnect()
        }
      }, 10000)
    }
  }

  const handleCameraStopResponse = (message: ResponseDataType<unknown>) => {
    const { Header } = message.responseData

    if (Header.ErrCode === Errcode.SUCCESS) {
      SessionRef.current?.disconnect()
      dispatch(ResetEmptyComponentStatus())
      dispatch(ResetCameraStatus())
      dispatch(ResetCallTime())

      dispatch(
        setModalItems({
          type: 'alert',
          text: t('MODAL.CAMERA_END', {
            defaultValue: 'Ending video Call',
          }) as string,
        }),
      )
    } else console.error(Header)
  }
}
export default useCameraEventBus
